export const routes = {
  auth: {
    main: "/auth",
    signUp: "/auth/sign-up",
    verifyAccount: "/auth/verify",
    setPassword: {
      linkSent: "/auth/set-password/link-sent",
      setPassword: "/auth/set-password/set-password",
      completed: "/auth/set-password/completed",
    },

    linkedIn: "/auth/linkedin",

    resetPassword: {
      main: "/auth/reset-password",
      linkSent: "/auth/reset-password/link-sent",
      setPassword: "/auth/reset-password/set-password",
      completed: "/auth/reset-password/completed",
    },
  },

  onboarding: { main: "/onboarding" },

  dashboard: { main: "/" },

  resume: { main: "/resume" },

  jobInterest: { main: "/job-interest" },

  assessment: { main: "/assessment", list: "/assessment/list" },

  college: { main: "/college" },

  jobSuggestions: { main: "/job-suggestions", view: "/job-suggestions/:id" },

  aiInterview: { main: "/ai-interview" },

  setting: { main: "/setting" },

  postHiring: { main: "/post-hiring" },

  support: { main: "/support" },

  unauthorized: "/401",
  notFound: "*",
};
